import axios from "axios";
import { APIS, LICENCE_ID } from "./utils/api-factory";
import { POST_HEADER } from "../../../../utils/apiHeaders";


export const saveUpdateCommunityPersonalApi = (userData, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    axios
      .post(APIS.SAVE_UPDATE_COMMUNITY_PERSONAL, userData, headerConfig)
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };


  export const getCommunityPersonalApi = (id, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    axios
      .get(APIS.GET_COMMUNITY_PERSONAL + id, headerConfig)
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };

  export const getLicenceApi = (
    pageNo,
    noOfRows,
    licenceSearch,
    callBack,
    error
  ) => {
    const headerConfig = {
      headers: {},
    };
    licenceSearch.emailId =
      licenceSearch.emailId === undefined ? "" : licenceSearch.emailId;
    licenceSearch.mobileNo =
      licenceSearch.mobileNo === undefined ? "" : licenceSearch.mobileNo;
    axios
      .get(
        APIS.GET_LICENCE +
          pageNo +
          "&noOfEntry=" +
          noOfRows +
          "&emailId=" +
          licenceSearch.emailId +
          "&mobileNo=" +
          licenceSearch.mobileNo,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };


  export const getLicenceCountApi = (licenceSearch, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    axios
      .get(
        APIS.GET_LICENCE_TABLE_COUNT +
          licenceSearch.emailId +
          "&mobileNo=" +
          licenceSearch.mobileNo,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };


  export const getNameOnPanApi = (data, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    axios
      .post(
        APIS.PAN_AUTHENTICATION_API + data.id + "&panNumber=" + data.panNumber,
        {},
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };


  export const saveUpdateAddressApi = (userData, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    console.log(userData);
    axios
      .post(APIS.SAVE_UPDATE_ADDRESS, userData, headerConfig)
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };


  export const getAddressDetailCommunityApi = (id, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    axios
      .get(APIS.GET_ADDRESS_DETAIL_COMMUNITY + id + "&type=", headerConfig)
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        error(e.message);
      });
  };
  

  export const getZipBranchDetailApi = (data, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    axios
      .get(
        APIS.GET_BANK_BRANCH_DETAIL + data.code + "&type=" + data.type,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };


  export const saveUpdateDocumentApi = (file, id, rowData, callBack, error) => {
    console.log(rowData, "rowdata");
    const headerConfig = {
      headers: {},
    };
    // console.log(rowData.licenseId)
    const type =
      file.type === "image/png"
        ? "img"
        : file.type === "application/pdf"
        ? "pdf"
        : file.type === "image/jpg"
        ? "img"
        : file.type === "image/jpeg"
        ? "img"
        : "";
    let multipartFormData = new FormData();
    multipartFormData.append(
      "replaceOrUpload",
      rowData.uploadedOrNot === "N" ? 0 : 1
    );
  
    multipartFormData.append("file", file);
    multipartFormData.append("documentId", id);
    multipartFormData.append("type", type);
    multipartFormData.append("fileName", file.name);
    multipartFormData.append(
      "lenderId",
      rowData.lenderId !== undefined ? rowData.lenderId : ""
    );
    multipartFormData.append(
      "licenseId",
      rowData.licenseId ? rowData.licenseId : LICENCE_ID
    );
    multipartFormData.append(
      "userId",
      rowData.userId !== undefined ? rowData.userId : ""
    );
    multipartFormData.append(
      "loanId",
      rowData.loanId !== undefined ? rowData.loanId : ""
    );
    multipartFormData.append(
      "communityId",
      rowData && rowData.communityId
        ? rowData.communityId
        : window.sessionStorage.getItem("communityId")
    );
  
    // if (rowData.communityId !== null && rowData.communityId !== undefined) {
    //     multipartFormData.append('communityId', rowData.communityId)
    // }
    axios
      .post(APIS.SAVE_UPDATE_DOCUMENT, multipartFormData, headerConfig)
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };

  export const getDocumentConfigApi = (
    pageNo,
    noOfRows,
    data,
    callBack,
    error
  ) => {
    console.log(data, "data");
    const licenseId = data.licenseId ? data.licenseId : LICENCE_ID;
    const product = data.product !== undefined ? data.product : "";
    const bussinessType =
      data.bussinessType !== undefined ? data.bussinessType : "";
    const sourceOfIncome =
      data.sourceOfIncome !== undefined ? data.sourceOfIncome : "";
    const loanId = data.loanId !== undefined ? data.loanId : "";
    const communityId = data.communityId !== undefined ? data.communityId : "";
    const lenderId = data.lenderId !== undefined ? data.lenderId : "";
    const stage = data.stage !== undefined ? data.stage : "";
  
    const headerConfig = {
      headers: {},
    };
    console.log(data);
    axios
      .get(
        APIS.GET_DOCUMENT_CONFIG +
          pageNo +
          "&noOfEntry=" +
          noOfRows +
          "&licenseId=" +
          licenseId +
          "&product=" +
          product +
          "&bussinessType=" +
          bussinessType +
          "&sourceOfIncome=" +
          sourceOfIncome +
          "&loanId=" +
          loanId +
          "&communityId=" +
          communityId +
          "&lenderId=" +
          lenderId +
          "&stage=" +
          stage,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };
  

  export const getDocumentCountApi = (data, callBack, error) => {
    const licenseId = data.licenseId ? data.licenseId : LICENCE_ID;
    const product = data.product !== undefined ? data.product : "";
    const headerConfig = {
      headers: {},
    };
    axios
      .get(
        APIS.GET_DOCUMENT_TABLE_COUNT + licenseId + "&product=" + product,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };

  export const getDocumentDetailApi = (
    pageNo,
    noOfRows,
    communityId,
  
    callBack,
    error
  ) => {
    const lenderId ="";
    const licenseId = "";
    const headerConfig = {
      headers: {},
    };
    axios
      .get(
        APIS.GET_DOCUMENT_DETAIL +
          pageNo +
          "&noOfEntry=" +
          noOfRows +
          "&lenderId=" +
          lenderId +
          "&licenseId=" +
          licenseId +
          "&communityId=" +
          communityId,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };


  export const SaveUploadFileDocDetails = (data, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    axios
      .post(
        APIS.SAVE_UPLOAD_FILE_DOC_DETAILS ,data,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };

  export const SaveUpdateDealerEvScorecard = (data, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    axios
      .post(
        APIS.SAVE_UPDATE_EVDEALER_SCORECARD ,data,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };

  export const SaveUpdateAccountDetailsDealer = (data, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    axios
      .post(
        APIS.SAVE_UPDATE_ACCOUNT_DETAILS_DEALER ,data,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };


  export const SaveUpdatePayoutConfig = (data, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    axios
      .post(
        APIS.SAVE_UPDATE_COMMUNITY_PAYOUT_CONFIG ,data,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };


  export const getAllCommunityForParentCommunity = ( callBack, error) => {
   
    axios
      .get(
        APIS.GET_ALL_COMMUNITY_FOR_PARENT_COMMUNITY )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };

  export const getCommunityAccountDetailsBycommunityId = (id, callBack, error) => {
   
    axios
      .get(
        APIS.GET_COMMUNITY_ACCOUNT_DETAIL_BY_COMMUNITYID + id )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };

  export const getCommunityPayoutDetailsBycommunityId = (id, callBack, error) => {
   
    axios
      .get(
        APIS.GET_COMMUNITY_PAYOUT_DETAIL_BY_COMMUNITYID + id )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };

  export const getStateListForDealer = ( callBack, error) => {
   
    axios
      .get(
        APIS.GET_STATE_LIST_FOR_DEALER  )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };
  export const getDistrcitStateListForDealer = (state, callBack, error) => {
   
    axios
      .get(
        APIS.GET_DISTRICT_STATE_LIST_FOR_DEALER + state  )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };